import { Component, OnInit } from '@angular/core';
import { AmbitService } from '../ambit.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.css']
})
export class TicketsComponent implements OnInit {
  public searchList: any = ['category', 'subject', 'name'];
  public sortColumn:any = 'status';
  public sortType:boolean = false ;
  
  public filterStatus:any = 'All';
  public searchQuery:any ;
  constructor(public service: AmbitService,
    public router: Router) {
      if(this.service.adminUser.userAccess.tickets =='None') {
        this.router.navigate(['/home']);
      }
     }

  ngOnInit() {
  }

  toggleSortValue(val) {
    if(this.sortColumn==val){
      this.sortType = !this.sortType ;
    } else {
      this.sortColumn = val;
    }
  }
  
}
